import { FunctionComponent, PropsWithChildren, ReactElement, useContext } from 'react';

import { DocumentContext } from '@philips-emr/tws-core/lib/component/context';
import { LocaleService } from '@philips-emr/tws-core/lib/services';
import { getBreakpoint, propagateProps } from '@philips-emr/tws-utils';

import ComponentNode from '../../core/component-node';
import { Props } from '../../metadata';

interface PMProps {
  engineComponent: ComponentNode;
  children: ReactElement | ReactElement[];
}

const PropsManager: FunctionComponent<PMProps> = (props: PropsWithChildren<PMProps>): ReactElement => {
  const { engineComponent, children, ...otherProps } = props;

  const docContext = useContext(DocumentContext);

  const breakpoint = getBreakpoint(docContext.window);
  const locale = LocaleService.getCurrentLocale();

  const procesedProps = engineComponent.getPropsProcessor().collect(otherProps as Props, breakpoint, locale);

  const listeners = engineComponent.getEventDelegator().collect(otherProps);

  return propagateProps(children, {
    ssot: engineComponent.getSSOT(),
    ...procesedProps,
    ...listeners,
  }) as unknown as ReactElement;
};

export default PropsManager;
